import React, { useContext, useState } from "react";
import classNames from "classnames";

import { HeaderNav } from "./header-nav";
import { ChatButton } from "../chat/chat-button";
import { ChatWindow } from "../chat/chat-inbox";
import ScrollToTop from "react-scroll-to-top";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { LanguageFlap } from "./languages";
import { LanguageContext } from "../../services/languages.context";
import { AppAlert } from "../utilities/app-alert";



export const AppHeader = ({data, onAlert}) => {
    const [showChat,setShowChat] = useState(false);
    const [chatMessage, setChatMessage] = useState('');

    const { switchLanguage, appLanguage } = useContext(LanguageContext);

    const toggleLanguage = () => {
        switchLanguage();
    }

   
    return (
        <header className={classNames("pd-xy-3","rw-al")}>
            { onAlert &&
                <AppAlert
                    caption={data.caption}
                    message={data.message}
                    abort={data.abort}
                    accept={data.accept}
                    handleAbort={data.handleAbort}
                    handleAccept={data.handleAccept}
                    handleClose={data.handleClose}
                />
            }
            <div className={classNames("app-img","rw-al-cnt","hs-3")}>
                <img src="/app-images/uest-logo-lg.png" className="app-logo" alt=""/>
            </div>
            <HeaderNav />
            <ChatWindow 
                visible={showChat} 
                show={() => setShowChat(setShowChat(false))}
                message={chatMessage}
                handleInput={(e) => {setChatMessage(e.target.value)}}
            />
            <LanguageFlap language={appLanguage} changeLanguage={toggleLanguage}/>
            <ChatButton handleClick={() =>setShowChat(true)}/>
            <ScrollToTop 
                smooth 
                className="scroll-to-top-btn" 
                component={(<FontAwesomeIcon icon={faArrowUp} color="#fff" />)}
            />
        </header>
    )
}